import React from 'react';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { onEnterAction } from '../utils/a11y';

interface Props {
  title: string;
  onClick(): void;
}

export const AlertWarning = ({ title, onClick }: Props): JSX.Element => (
    <div
      aria-label={title}
      className='flex items-center p-6 border-l-2 border-tangerine cursor-pointer hover:bg-gray-100 shadow-md'
      onClick={onClick}
      onKeyDown={(e): void => onEnterAction(e, onClick)}
      role='button'
      tabIndex={0}
    >
      <div className='flex items-center w-5 h-5 rounded-full justify-center text-white bg-tangerine'>
        <FontAwesomeIcon icon={faExclamation} />
      </div>

      <div className='flex-grow pl-2 text-medium text-black'>
        {title}
      </div>
      <div className='flex-shrink-0 text-gray-400 pl-2'>
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
    </div>
  );
